export default __webpack_public_path__ + "static/anilPokhriyal7-2560a05e9240da80b16f69414cced5a9.jpg";